import * as angular from 'angular';
import { MeurhAdmissoesestagiarioValetransportepersonalizadoFormController } from './valetransportepersonalizado.form.controller';

export class MeurhAdmissoesestagiarioValetransportepersonalizadoFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesestagiarioValetransportepersonalizadoFormComponent';
	static controller = MeurhAdmissoesestagiarioValetransportepersonalizadoFormController;
	static template = require('!!html-loader!./valetransportepersonalizado.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
